/* @flow */
import React from 'react';
import moment from 'moment';
import { ActionButton, DataTable, ListLargeText } from 'listertech-commons-web';
import type { Visit } from 'data/visits';

type Props = {
  data: Visit[],
  onSort: (index: number) => void,
  onEdit: (id: string) => void,
  onCancel: (id: string) => void,
};



const OpenTable = (props: Props) => {

  const dataByNewestVisit = [...props.data]
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()); // soonest first
    
  return (
    <DataTable
      name="open-visits"
      headers={['Patient Name', 'Date', 'Type', 'City', 'Agency', 'Action']}
      data={dataByNewestVisit}
      renderers={[
        (v: Visit) => <ListLargeText>{v.patient.name}</ListLargeText>,
        (v: Visit) => (
          <ListLargeText>{moment(v.date).format('MM/DD')}</ListLargeText>
        ),
        (v: Visit) => <ListLargeText>{v.type}</ListLargeText>,
        (v: Visit) => <ListLargeText>{v.patient.city}</ListLargeText>,
        (v: Visit) => <ListLargeText>{v.agencyName}</ListLargeText>,
        (v: Visit) => (
          <React.Fragment>
            <ActionButton
              green
              onClick={e => {
                e.preventDefault();
                props.onDuplicate(v.id);
            }}
            >
              Duplicate
            </ActionButton>
            <ActionButton
              red
              onClick={e => {
                e.preventDefault();
                props.onCancel(v.id);
              }}
              key={`open-visits-cancel-${v.id}`}
            >
              Cancel
            </ActionButton>
            <ActionButton
              onClick={e => {
                e.preventDefault();
                props.onEdit(v.id);
              }}
              key={`open-visits-edit-${v.id}`}
            >
              Edit
            </ActionButton>
          </React.Fragment>
        ),
      ]}
      onSort={props.onSort}
    />
  );
};

export default OpenTable;
